module.exports = __webpack_public_path__ + "img/brandy_crusta.f4cc4d46.jpg";